<template>
  <div>
    <b-button @click.prevent="openModal" class="float-right" v-if="id === 0">{{ title }}</b-button>
    <a href="" @click.prevent="openModal" v-if="id !== 0"><i class="fa fa-lg fa-edit"></i></a>
    <b-modal size="xl" :id="`create-modal-${id}`" :title="title" @show="getUser" @hide="resetForm" @ok="saveUser">
      <b-spinner v-if="loading"></b-spinner>
      <b-form v-if="ready">
        <b-form-group label="Usuario">
          <b-form-input autocomplete="nope" v-model="form.username" required />
        </b-form-group>
        <b-form-group label="Nombre">
          <b-form-input autocomplete="nope" id="first_name" v-model="form.first_name"></b-form-input>
        </b-form-group>
        <b-form-group label="Apellido">
          <b-form-input autocomplete="nope" id="last_name" v-model="form.last_name"></b-form-input>
        </b-form-group>
        <b-form-group label="Email">
          <b-form-input autocomplete="nope" v-model="form.email"></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            id="is_active"
            v-model="form.is_active"
            name="is_active"
            :value="true"
            :unchecked-value="false"
          >
            Activo
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="is_superuser">
          <b-form-checkbox id="is_staff" v-model="form.is_staff" name="is_staff" :value="true" :unchecked-value="false">
            Administrador
          </b-form-checkbox>
        </b-form-group>
        <b-form-group label="Permisos">
          <template #label>
            Permisos
            <a href="" @click.prevent="selectAll()" class="mx-2">Seleccionar todo</a>
            <a href="" @click.prevent="selectNone()" class="mx-2 text-danger">Desmarcar todo</a>
          </template>
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="form.scope"
            :options="scope_options"
            name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import getScope from "../../utils/scope";
import scopeDict from "../../lang/scopeDict";

const scope = getScope();

// Find missing scopes in scopeDict
export default {
  data() {
    return {
      ready: false,
      loading: false,
      is_superuser: false,
      scope_options: [],
      form: {
        username: "",
        first_name: "",
        last_name: "",
        is_active: false,
        is_staff: false,
        email: "",
        scope: []
      }
    };
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "Crear usuario"
    }
  },
  computed: {
    ...mapGetters({
      scopes: "getScopedMenu"
    })
  },
  methods: {
    resetForm() {
      this.form = {
        username: "",
        first_name: "",
        last_name: "",
        is_active: false,
        is_staff: false,
        email: "",
        password: "",
        scope: []
      };
    },
    selectAll() {
      this.form.scope = this.scope_options.map((option) => option.value);
    },
    selectNone() {
      this.form.scope = [];
    },
    // openModal() {
    //   this.$bvModal.show(`create-modal-${this.id}`);
    //   this.scope_options = scope;
    // },
    openModal() {
      this.$bvModal.show(`create-modal-${this.id}`);
      this.scope_options = scope.map((s) => {
        return {
          value: s,
          text: scopeDict[s] || s
        };
      });
    },
    async saveUser() {
      this.loading = true;
      let method = "post";
      let url = "/menu/user/";
      if (this.id !== 0) {
        method = "put";
        url = url + `${this.form.id}/`;
      }
      try {
        const response = await this.$axios({
          url,
          method,
          data: this.form
        });
        this.$bvModal.hide(`create-modal-${this.id}`);
        this.$bvToast.toast(`Usuario ${response.data.username} creado con éxito`, {
          title: "Éxito",
          variant: "success"
        });
        this.$emit("on-save-success");
        this.resetForm();
      } catch (error) {
        this.$bvToast.toast(`Error al crear el usuario`, {
          title: "Error",
          variant: "danger"
        });
      }
      this.loading = false;
    },
    async getUser() {
      this.ready = false;
      this.loading = true;
      if (this.id !== 0) {
        try {
          const response = await this.$axios.get(`/menu/user/${this.id}/`);
          this.form = response.data;
          this.loading = false;
        } catch (error) {
          console.log(error);
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
      this.$nextTick(() => {
        this.ready = true;
      });
    }
  },
  mounted() {
    this.is_superuser = this.$store.state.user.SUPERUSER;
  }
};
</script>

<style></style>
